import React, { useCallback, useState } from 'react';
import { Modal, message } from 'antd';
import styled from '@emotion/styled';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { GRAPHICS } from '../../../../../../constants/define/translation';
import { SpinLoading } from '../../../../../atoms/loading/SpinLoading';
import { appStyles } from '../../../../../../styles';
import { WIDTH_MODAL } from '../../../../../../constants/common';
import { logging } from '../../../../../../utils/log';
import { FormAddUpdateText } from './FormAddUpdateText';
import { saveTextRepository, updateTextRepository } from '../../../../../../repository/mytm/text/textRepository';

interface CreateTextModalProps {
  isOpenModal: boolean;
  onClose: () => void;
  record?: any;
  onRefresh: (loading?: boolean) => void;
}

export const CreateTextModal = (props: CreateTextModalProps) => {
  const { t } = useTranslation(GRAPHICS);
  const { isOpenModal, onClose, onRefresh, record } = props;
  const [isLoading, setIsLoading] = useState(false);

  const onCreateText = async (dataSave: any) => {
    await saveTextRepository({
      ...dataSave,
    });
    message.success(t('message.createText'));
  };

  const onUpdateText = async (dataSave: any) => {
    const payload = {
      ...dataSave,
      id: record.id,
    };
    await updateTextRepository(payload);
    message.success(t('message.updateText'));
  };

  const onSaveText = useCallback(
    async dataSave => {
      try {
        setIsLoading(true);
        if (record) {
          await onUpdateText(dataSave);
        } else {
          await onCreateText(dataSave);
        }
        setIsLoading(false);
        onClose();
        onRefresh(true);
      } catch (error: any) {
        setIsLoading(false);
        logging(error);
        message.error(error?.errorMessage || t('message.addUpdateTextFail'));
      } finally {
        setIsLoading(false);
      }
    },
    [record, onClose],
  );

  return (
    <StyledModal
      centered
      visible={isOpenModal}
      width={WIDTH_MODAL}
      footer={null}
      onCancel={() => {
        onClose();
      }}
      maskClosable={false}
      closeIcon={<CloseCircleOutlined />}
    >
      <SpinLoading isLoading={isLoading} absolute>
        <>
          <FormAddUpdateText onSaveText={onSaveText} record={record} />
        </>
      </SpinLoading>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  & > .ant-modal-content {
    ${appStyles.commonModalContentStyle}
  }

  .site-card-wrapper {
    ${appStyles.background.modalBgGray}
    & .card-item {
      text-align: center;
      padding: 1rem;
    }
  }

  & h4.ant-typography {
    ${appStyles.color.black}
  }

  .ant-modal-header {
    padding-left: 0;
  }

  .card-item .ant-Text {
    cursor: pointer;
  }

  & .card-up-to-date {
    & .ant-Text {
      padding: 0px;
      margin-left: 12px;
      & img {
        width: 92%;
        padding: 5px 0 0px 0;
      }
    }
  }
`;
